import { ChangeDetectorRef, Component, ElementRef, Inject, OnInit, PLATFORM_ID, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { UserModel } from 'src/app/Models/UserModel';
import { CacheService } from 'src/app/services/cache.service';
import { ForumService } from 'src/app/services/forum.service';
import { StorageService } from 'src/app/services/storage.service';
import { StorageKey, StorageType } from 'src/app/storage-key';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { DatePipe, DOCUMENT, isPlatformBrowser } from '@angular/common';
import { mergeMap } from 'rxjs';
import { ImageUploadService } from 'src/app/services/image-upload.service';
import { Guid } from 'guid-typescript';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { NotificationService } from 'src/app/services/notification.service';
import { NotificationType } from 'src/app/enum/NotificationType';
import { Location } from '@angular/common';
import { SubCategoryModel } from 'src/app/Models/SubCategoryModel';
import { CategoryListModel } from 'src/app/Models/CategoryListModel';
import { SubCategoryList } from 'src/app/Models/ModelsList/SubCategoryList';
import { CategoryList } from 'src/app/Models/ModelsList/CategoryList';
import { QuestionURLPattern } from 'src/app/enum/QuestionURLPattern';
import { MetaContentService } from 'src/app/services/meta-content.service';
import { HtmlToSimpleTextPipe } from 'src/app/pipes/html-to-simple-text.pipe';
import { BlogService } from 'src/app/services/blog.service';
import { SourceIdEnum } from 'src/app/Models/sourceIdEnumModel';
import { LoginWithEmailComponent } from 'src/app/popupModel/login-with-email/login-with-email.component';
import { en, fa } from 'intl-tel-input/i18n';
import { environment } from 'src/environments/environment';

declare var $: any;
@Component({
  selector: 'app-batch-discussion-qa-form',
  templateUrl: './batch-discussion-qa-form.component.html',
  styleUrls: ['./batch-discussion-qa-form.component.css'],
  providers: [HtmlToSimpleTextPipe],
})
export class BatchDiscussionQaFormComponent implements OnInit {
  ParentCategory: any[] = [
    { id: 12, name: '12 grade' },
    { id: 11, name: '11 grade' },
    { id: 10, name: '10 grade' },
    { id: 9, name: '9 grade' },
    { id: 8, name: '8 grade' },
    { id: 7, name: '7 grade' },
    { id: 6, name: '6 grade' },
  ];

  SubCategory: any = [
    { id: 1, name: 'Entrance Exam', ParentCategory: 11 },
    { id: 2, name: 'Physics (Class 11)', ParentCategory: 11 },
    { id: 3, name: 'Chemistry (Class 11)', ParentCategory: 11 },
    { id: 4, name: 'Mathematics (Class 11)', ParentCategory: 11 },
    { id: 5, name: 'Biology (Class 11)', ParentCategory: 11 },
    { id: 6, name: 'Entrance Exam', ParentCategory: 12 },
    { id: 7, name: 'Physics (Class 12)', ParentCategory: 12 },
    { id: 8, name: 'Chemistry (Class  12)', ParentCategory: 12 },
    { id: 9, name: 'Mathematics (Class 12)', ParentCategory: 12 },
    { id: 10, name: 'Biology (Class  12)', ParentCategory: 12 },
    { id: 50, name: 'Maths', ParentCategory: 6 },
    { id: 49, name: 'Science', ParentCategory: 6 },
    { id: 48, name: 'Maths', ParentCategory: 7 },
    { id: 47, name: 'Science', ParentCategory: 7 },
    { id: 46, name: 'Maths', ParentCategory: 8 },
    { id: 45, name: 'Science', ParentCategory: 8 },
    { id: 44, name: 'Maths', ParentCategory: 9 },
    { id: 43, name: 'Science', ParentCategory: 9 },
    { id: 42, name: 'Maths', ParentCategory: 10 },
    { id: 41, name: 'Science', ParentCategory: 10 },
  ];

  TopicCategory: any = [
    { id: 7, name: 'Most Scoring Topics in IIT JEE', SubCategory: 1 },
    { id: 37, name: 'IIT JEE Entrance Exam', SubCategory: 1 },
    { id: 2, name: 'Discuss with Colleagues and IITians', SubCategory: 1 },
    { id: 39, name: 'Engineering Entrance Exams', SubCategory: 1 },
    { id: 8, name: 'Branch Ranking of IIT', SubCategory: 1 },
    { id: 33, name: 'Discuss with Askiitians Tutors', SubCategory: 1 },
    { id: 55, name: 'NEET[AIPMT]', SubCategory: 1 },
    { id: 6, name: 'Marks and Rank in IIT JEE', SubCategory: 1 },
    { id: 54, name: 'AIIMS MBBS', SubCategory: 1 },
    { id: 5, name: 'Top Engineering Colleges in India', SubCategory: 1 },
    { id: 38, name: 'AIEEE Entrance Exam', SubCategory: 1 },
    { id: 32, name: 'General Knowledge', SubCategory: 1 },

    { id: 7, name: 'Most Scoring Topics in IIT JEE', SubCategory: 6 },
    { id: 37, name: 'IIT JEE Entrance Exam', SubCategory: 6 },
    { id: 2, name: 'Discuss with Colleagues and IITians', SubCategory: 6 },
    { id: 39, name: 'Engineering Entrance Exams', SubCategory: 6 },
    { id: 8, name: 'Branch Ranking of IIT', SubCategory: 6 },
    { id: 33, name: 'Discuss with Askiitians Tutors', SubCategory: 6 },
    { id: 55, name: 'NEET[AIPMT]', SubCategory: 6 },
    { id: 6, name: 'Marks and Rank in IIT JEE', SubCategory: 6 },
    { id: 54, name: 'AIIMS MBBS', SubCategory: 6 },
    { id: 5, name: 'Top Engineering Colleges in India', SubCategory: 6 },
    { id: 38, name: 'AIEEE Entrance Exam', SubCategory: 6 },
    { id: 32, name: 'General Knowledge', SubCategory: 6 },

    { id: 10, name: 'Mechanics', SubCategory: 2 },
    { id: 14, name: 'Electric Current', SubCategory: 2 },
    { id: 11, name: 'Wave Motion', SubCategory: 2 },
    { id: 15, name: 'Magnetism', SubCategory: 2 },
    { id: 18, name: 'Modern Physics', SubCategory: 2 },
    { id: 12, name: 'Thermal Physics', SubCategory: 2 },
    { id: 16, name: 'Electromagnetic Induction', SubCategory: 2 },
    { id: 9, name: 'General Physics', SubCategory: 2 },
    { id: 13, name: 'Electrostatics', SubCategory: 2 },
    { id: 17, name: 'Wave Optics', SubCategory: 2 },
    { id: 60, name: 'Physics Others', SubCategory: 2 },

    { id: 10, name: 'Mechanics', SubCategory: 7 },
    { id: 14, name: 'Electric Current', SubCategory: 7 },
    { id: 11, name: 'Wave Motion', SubCategory: 7 },
    { id: 15, name: 'Magnetism', SubCategory: 7 },
    { id: 18, name: 'Modern Physics', SubCategory: 7 },
    { id: 12, name: 'Thermal Physics', SubCategory: 7 },
    { id: 16, name: 'Electromagnetic Induction', SubCategory: 7 },
    { id: 9, name: 'General Physics', SubCategory: 7 },
    { id: 13, name: 'Electrostatics', SubCategory: 7 },
    { id: 17, name: 'Wave Optics', SubCategory: 7 },
    { id: 64, name: 'Physics Others', SubCategory: 7 },

    { id: 19, name: 'Physical Chemistry', SubCategory: 3 },
    { id: 21, name: 'Organic Chemistry', SubCategory: 3 },
    { id: 20, name: 'Inorganic Chemistry', SubCategory: 3 },
    { id: 19, name: 'Physical Chemistry', SubCategory: 8 },
    { id: 21, name: 'Organic Chemistry', SubCategory: 8 },
    { id: 20, name: 'Inorganic Chemistry', SubCategory: 8 },
    { id: 61, name: 'Chemistry Others', SubCategory: 3 },
    { id: 65, name: 'Chemistry Others', SubCategory: 8 },

    { id: 22, name: 'Algebra', SubCategory: 4 },
    { id: 23, name: 'Trigonometry', SubCategory: 4 },
    { id: 24, name: 'Analytical Geometry', SubCategory: 4 },
    { id: 25, name: 'Differential Calculus', SubCategory: 4 },
    { id: 26, name: 'Integral Calculus', SubCategory: 4 },
    { id: 27, name: 'Vectors', SubCategory: 4 },
    { id: 29, name: 'Magical Mathematics[Interesting Approach]', SubCategory: 4 },
    { id: 62, name: 'Maths Others', SubCategory: 4 },

    { id: 22, name: 'Algebra', SubCategory: 9 },
    { id: 23, name: 'Trigonometry', SubCategory: 9 },
    { id: 24, name: 'Analytical Geometry', SubCategory: 9 },
    { id: 25, name: 'Differential Calculus', SubCategory: 9 },
    { id: 26, name: 'Integral Calculus', SubCategory: 9 },
    { id: 27, name: 'Vectors', SubCategory: 9 },
    { id: 29, name: 'Magical Mathematics[Interesting Approach]', SubCategory: 9 },
    { id: 66, name: 'Maths Others', SubCategory: 9 },

    { id: 52, name: 'Botany', SubCategory: 5 },
    { id: 53, name: 'Zoology', SubCategory: 5 },
    { id: 63, name: 'Biology Others', SubCategory: 5 },

    { id: 52, name: 'Botany', SubCategory: 10 },
    { id: 53, name: 'Zoology', SubCategory: 10 },
    { id: 67, name: 'Biology Others', SubCategory: 10 },
  ];

  dropdownSettings: IDropdownSettings = {
    singleSelection: false,
    idField: 'value',
    textField: 'label',
    selectAllText: 'Select All',
    itemsShowLimit: 6,
    allowSearchFilter: true,
    noDataAvailablePlaceholderText: 'Data Not Available',
    unSelectAllText: 'Un-Select All',
  };
  selectedGrade: string = this.ParentCategory[0].id;
  selectedsubCategory: any;
  gradeID: string = this.ParentCategory[0].id;
  show: boolean = false;
  dropdownCategory: any[] = [];
  selectedName: any;
  selectedID: any;
  getCatList: any;
  metaContent: any;
  dropdownsubCategory: any;
  ResourcegradeId: string = '';
  htmlContent: string = '';
  sharedData: string = '';
  searchQuestion: any;
  listshow: boolean = false;
  forum!: FormGroup;
  subjectId: string = '';
  userDetails!: UserModel;
  tags: any[] = [];
  selectedTags: any[] = [];
  imageName: any;
  img: any;
  imagePath: any;
  imageId: any;
  categoryName!: string;
  forumQuestion!: FormGroup;
  forumQuestiontags!: FormGroup;
  showMore: boolean = false;
  isSubmitted = false;
  isHtmlContent = false;
  UserId!: Number;
  isViewAllPrevious: boolean = false;
  isViewAllNext: boolean = false;
  isViewAll: boolean = false;
  startIndex = 0;
  endIndex = 5;
  questionSimpleText!: string;
  selectedSubCategory!: string;
  selectedSubTopicCategory!: string;
  pageLenght!: number;
  blogs: any;
  blogCategory: string = 'post';
  isSubCategory: boolean = false;
  isCategory: boolean = false;
  cacheResourceData: any;
  imageUrl: string | null = null;
  fileToUpload!: File;
  selectedFile: boolean = false;
  GoogleRE_CAPTCHA_IsEnabled = environment.GoogleRE_CAPTCHA_IsEnabled;
  // environment = environment;
  isAnsweUploaded = false;
  isLoading: boolean = false;
  prohibitedPatterns: string[] = [];

  initialValue = {
    grade: this.ParentCategory[0].id,
    category: '--select--',
    subcategory: '--select--',
    imagequestion: '',
    tag: null,
  };
  check = false;
  isCheckNext = false;
  isCheckPrevious = false;
  isReadMore: boolean = true;
  isButtonDisabled: boolean = true; // Note: make it false once it resolve
  category!: string | null;
  categorydata: any;
  categoryId: string = '';
  categoryURL: any;
  parentCategoryData: any;
  gradeData: any;
  categoryToRedirect!: string | null;
  categoryDataLenght!: number;
  subCategoryList: Array<SubCategoryModel> = [] as Array<SubCategoryModel>;
  categoryList: Array<CategoryListModel> = [] as Array<CategoryListModel>;
  userSubscribe: any;
  cacheSubscribe: any;
  isValidQuestion: boolean = true;
  isDescribedQuestion: boolean = false;
  tabId: string | undefined;
  script!: HTMLScriptElement;
  link!: HTMLLinkElement;
  @ViewChild('editor', { static: false }) editor!: ElementRef;
  htmlContentOfEditor: string = '';
  isInputDisabled: boolean = false;
  uploadedImagePath!: string;
  simpleText!: string;
  isPaidUser!: boolean;
  isCaptchaVerified!: boolean;
  constructor(
    private cacheService: CacheService,
    private forumService: ForumService,
    public formBuilder: FormBuilder,
    private storage: StorageService,
    private modalService: NgbModal,
    private datePipe: DatePipe,
    private imageUploadService: ImageUploadService,
    private notificationService: NotificationService,
    private location: Location,
    private route: ActivatedRoute,
    private metaSetvice: MetaContentService,
    private htmlToSimpleText: HtmlToSimpleTextPipe,
    private router: Router,
    private blogService: BlogService,
    @Inject(PLATFORM_ID) private platformId: any,
    private cdRef: ChangeDetectorRef,
    @Inject(DOCUMENT) private document: any
  ) {
    this.subCategoryList = SubCategoryList.subCategoryItems;
    this.categoryList = CategoryList.CategoryList;
  }

  ngOnInit() {
    //minor change
    this.category = this.route.snapshot.paramMap.get('category');
    if (this.category == null || this.category == undefined || this.category == '') {
      this.populateCategory(this.ParentCategory[0].id);
      this.location.replaceState('/forums/');
      this.metaSetvice.updateMetaContent(
        'Engineering entrance forum, discussion board, open forum, online engineering discussion forum, ask questions to online experts, open forum',
        'a askIITians offers free registration at the IIT JEE discussion forum for discussion of problems of Math, Physics & chemistry of IIT JEE and Math & science problems of grades 6, 7, 8, 9 & 10 with the help of JEE experts.',
        'IIT JEE Discussion Forum – Ask questions & Get Answers of Math, Physics & Chemistry from JEE Experts | askIITians',
        null,
        'forums/',
        'forum'
      );
    } else {
      this.location.replaceState('/forums/' + this.category.toLocaleLowerCase() + '/');
      this.checkInTopicCategory(this.category.toLocaleLowerCase());
    }

    this.forumQuestion = this.formBuilder.group({
      grade: [this.gradeID, Validators.required],
      category: ['', Validators.required],
      subCategory: ['', Validators.required],
    });
    this.forumQuestiontags = this.formBuilder.group({
      imageQuestion: ['', Validators.required],
      //tags: ['', Validators.required],
    });
    this.userSubscribe = this.cacheService._userDetails.subscribe((res) => {
      if (res != null) {
        this.userDetails = res;
        this.UserId = this.userDetails.id;
      }
    });
    // if (this.storage.getItem(StorageKey.ISPAID, StorageType.LOCAL) == 'true') {
    //   this.isPaidUser = true;
    // }
    this.cacheService._isPaidUser.subscribe((res) => {
      if (res != null) {
        this.isPaidUser = res;
      }
    });

    this.cacheSubscribe = this.cacheService._resourceData.subscribe((res) => {
      this.cacheResourceData = res;
      if (res != null) {
        if (res.gradeId == '12' && res.htmlContent == '' && res.subjectId == '' && res.isResourcePage == true) {
          this.ResourcegradeId = res.gradeId;
          this.subjectId = res.subjectId;
          this.sharedData = res.htmlContent;
        } else if (res == false && !this.category) {
          this.populateCategory(this.ParentCategory[0].id);
        } else if (res == false && this.category) {
          this.checkInTopicCategory(this.category);
        } else {
          this.ResourcegradeId = res.gradeId;
          this.subjectId = res.subjectId;
          this.sharedData = res.htmlContent;
          this.gradeID = this.ResourcegradeId;
          this.forumQuestion.controls['grade'].setValue(this.ResourcegradeId);
          if (Number(this.ResourcegradeId) > 10) {
            this.show = false;
          } else {
            this.show = true;
            this.isSubCategory = false;
          }
          this.dropdownCategory = this.SubCategory.filter(
            (i: { ParentCategory: any }) => i.ParentCategory == Number(this.ResourcegradeId)
          );
          if (this.sharedData.startsWith('&#160;')) {
            this.isValidQuestion = false;
            this.isLoading = false;
          } else {
            this.isValidQuestion = true;
            this.isLoading = false;
          }
        }
      }
    });

    // this.forumService.getForumTagList().subscribe((data) => {
    //   data.items.forEach((element: any) => {
    //     this.tags.push({ label: element.stringValue, value: element.dataId });
    //   });
    // });

    if (this.startIndex == 0) {
      this.isViewAllPrevious = false;
      this.isViewAllNext = true;
    }
    this.getBlogData();
    this.loadProhibitedPatterns();
  }

  loadProhibitedPatterns() {
    this.forumService.getProhibitedPatterns().subscribe((patterns: string[]) => {
      this.prohibitedPatterns = patterns;
      //console.log('Loaded prohibited patterns:', this.prohibitedPatterns);
    });
  }
  populateCategory(id: any) {
    this.isSubmitted = false;
    if (this.selectedGrade != id) {
      this.gradeID = id;
      if (id > 10) {
        this.show = false;
      } else {
        this.show = true;
        this.isSubCategory = false;
      }

      this.selectedSubTopicCategory = '';
      this.dropdownCategory = this.SubCategory.filter((i: { ParentCategory: any }) => i.ParentCategory == id);
    } else {
      this.gradeID = id;
      this.selectedSubCategory = '';
      this.selectedSubTopicCategory = '';

      if (id > 10) {
        this.show = false;
      } else {
        this.show = true;
      }
      this.dropdownCategory = this.SubCategory.filter((i: { ParentCategory: any }) => i.ParentCategory == id);
    }
    // this.loadCSS();
  }

  subCategories(id: any) {
    this.isSubCategory = false;
    this.isCategory = true;
    this.dropdownsubCategory = this.TopicCategory.filter((i: { SubCategory: any }) => i.SubCategory == id);
    let index = this.dropdownCategory.findIndex((x: { id: any }) => x.id == id);
    var numberValue = Number(index);
    this.selectedName = this.dropdownCategory[numberValue]?.name;
    this.selectedID = this.dropdownCategory[numberValue]?.id;
    if (this.selectedID >= 11) {
      this.category = this.selectedName.replaceAll(' ', '-');
      this.categoryToRedirect = this.category;
      this.categoryName = this.gradeID + ' grade ' + this.category?.toLocaleLowerCase();
      this.location.replaceState('/forums/' + this.gradeID + '-grade-' + this.category?.toLocaleLowerCase() + '/');
    }
    if (this.categoryId == '' && !this.categoryId) {
      this.getCatList = [];
      if (Number(this.gradeID) <= 10) {
        this.forumService.getDataByCat(id, this.startIndex, this.endIndex, this.gradeID).subscribe((data: any) => {
          this.getCatList = data.forumCategoryDetail;
          // this.loadCSS();
          if (this.getCatList.length < 5) {
            this.isViewAllNext = false;
          } else {
            this.isViewAllNext = true;
          }
          this.categoryToRedirect = this.gradeID + '-grade-' + this.category?.toLocaleLowerCase();
          this.metaContent = data.forumCategoryMeta;
          this.metaSetvice.updateMetaContent(
            this.metaContent.keyword,
            this.metaContent.description,
            this.metaContent.title,
            null,
            'forums/' + this.gradeID + '-grade-' + this.selectedName.toLocaleLowerCase() + '/',
            'forum'
          );
        });
      }
    }
  }

  Categories(id: any) {
    if (id == '') {
      this.location.replaceState('/forums/');
    } else {
      this.isSubCategory = true;
      this.isCategory = false;
      let index = this.dropdownsubCategory.findIndex((x: { id: any }) => x.id == id);
      var numberValue = Number(index);
      this.selectedName = this.dropdownsubCategory[numberValue]?.name;
      this.selectedID = this.dropdownsubCategory[numberValue]?.id;
      this.getCatList = [];
      this.forumService.getDataByCat(id, this.startIndex, this.endIndex, this.gradeID).subscribe((data: any) => {
        this.category = this.selectedName.replaceAll(' ', '-').replaceAll('(', '-').replaceAll(')', '');
        this.categoryToRedirect = this.category;
        this.getCatList = data.forumCategoryDetail;
        this.categoryDataLenght = this.getCatList.forumCategoryDetail?.length;
        this.categoryName = this.selectedName;
        // this.loadCSS();
        if (this.getCatList.length < 5) {
          this.isViewAllNext = false;
        } else {
          this.isViewAllNext = true;
        }
        this.location.replaceState(
          '/forums/' +
            this.selectedName.replaceAll(' ', '-').replaceAll('(', '-').replaceAll(')', '').toLocaleLowerCase() +
            '/'
        );
        if (this.gradeID >= '10') {
          this.category = this.selectedName.replaceAll(' ', '-');
          const regex = /^Physics-|Chemistry-|Maths-|Biology-|Others\/$/;
          if (regex.test(this.category || '')) {
            this.categoryToRedirect = this.gradeID + '-grade-' + this.category?.toLocaleLowerCase();
            this.category = this.categoryToRedirect;
            this.location.replaceState('/forums/' + this.category + '/');
          } else {
            this.categoryToRedirect = this.category;
          }
          this.metaContent = data.forumCategoryMeta;
          this.metaSetvice.updateMetaContent(
            this.metaContent.keyword,
            this.metaContent.description,
            this.metaContent.title,
            null,
            'forums/' + this.category?.toLocaleLowerCase() + '/',
            'forum'
          );
        }
        // this.loadCSS();
      });
    }
  }

  searchSimilarQua(val: string) {
    // TODO: Refactor the logic here to avoid the second replace. The white space are coming this way.
    // replace(/<[^>]*>/g, '')
    this.sharedData = val;
    if (this.sharedData.replace(/<[^>]*>/g, '').startsWith('&#160;')) {
      this.isValidQuestion = false;
      this.isLoading = false;
    } else {
      if (this.sharedData.length < 2) {
        this.isValidQuestion = true;
        this.isLoading = false;
        return;
      } else {
        this.forumService.getSimilarQuestion(this.sharedData).subscribe({
          next: (data) => {
            this.searchQuestion = data;
            this.listshow = true;
          },
          error: (error) => {
            console.log(error);
          },
        });
      }
    }
  }
  checkParagraph(paragraph: string): { contains: boolean; matches: string[] } {
    const matches: string[] = [];
    const lowerParagraph = paragraph.toLowerCase();

    this.prohibitedPatterns.forEach((pattern) => {
      try {
        if (pattern.startsWith('(') || pattern.includes('\\d')) {
          // Treat as regex
          const regex = new RegExp(pattern, 'gi');
          if (regex.test(paragraph)) {
            matches.push(pattern);
          }
        } else {
          // Normal word/phrase
          if (lowerParagraph.includes(pattern.toLowerCase())) {
            matches.push(pattern);
          }
        }
      } catch (err) {
        console.error('Invalid regex pattern:', pattern, err);
      }
    });

    return {
      contains: matches.length > 0,
      matches,
    };
  }

  onSubmit() {
    //check checkParagraph here
    this.simpleText = this.htmlToSimpleText.getHtmlSimpleText(this.htmlContent);
    this.simpleText = this.htmlToSimpleText.RemoveHTML(this.simpleText);
    this.check = true;
    // Ensure prohibitedPatterns is always an array before using forEach
    if (!Array.isArray(this.prohibitedPatterns)) {
      try {
        this.prohibitedPatterns = JSON.parse(this.prohibitedPatterns);
      } catch (e) {
      }
    }
    const paragraphCheck = this.checkParagraph(this.simpleText);
    if (paragraphCheck.contains) {
      const prohibitedList = paragraphCheck.matches.join(', ');
      this.notificationService.notifyMessage(
        NotificationType.Success,
        `Question saved. It will be visible once it has been approved by our team.`
      );
      //this.isValidQuestion = false;
      return;
    } else {
      if (this.simpleText.length >= 50) {
        if (
          this.forumQuestiontags.controls['imageQuestion'].invalid == false &&
          (this.htmlContent == '' || this.htmlContent == undefined)
        ) {
          // this.isDescribedQuestion = true;
          this.isValidQuestion = false;
          this.isLoading = false;
        } else if (
          this.forumQuestiontags.controls['imageQuestion'].valid == true &&
          (this.htmlContent == '' || this.htmlContent == undefined)
        ) {
          this.isValidQuestion = true;
          this.isLoading = false;
          // this.isValidQuestion = false;
        } else {
          //this.isDescribedQuestion = false;
          this.isValidQuestion = true;
          this.isLoading = false;
        }

        if (this.gradeID == '12' || this.gradeID == '11') {
          if (
            this.forumQuestion.controls['grade'].invalid ||
            this.forumQuestion.controls['category'].invalid ||
            this.forumQuestion.controls['subCategory'].invalid ||
            this.htmlContent == '' ||
            this.isValidQuestion == false
          ) {
            this.isHtmlContent = false;
            this.isLoading = false;
            return;
          } else {
            this.validateForm();
          }
        } else if (this.isSubCategory == false) {
          if (
            this.forumQuestion.controls['grade'].invalid ||
            this.forumQuestion.controls['category'].invalid ||
            this.forumQuestion.controls['subCategory'].invalid ||
            this.htmlContent == '' ||
            this.isValidQuestion == false
          ) {
            if (this.forumQuestion.controls['subCategory'].invalid == true) {
              this.forumQuestion.controls['subCategory'].setValue('false');
              this.isHtmlContent = true;
              this.validateForm();
            } else {
              return;
            }
          } else {
            this.validateForm();
          }
        } else {
        }
      } else {
        this.isValidQuestion = false;
      }
    }
  }
  validateForm() {
    this.isLoading = true;
    this.check = true;
    this.isButtonDisabled = true;
    if (!this.userDetails) {
      const sourceId = SourceIdEnum.Forum;
      this.isLoading = false;
      const modalRef = this.modalService.open(LoginWithEmailComponent, { centered: true, backdrop: 'static' });
      modalRef.componentInstance.sourceId = sourceId;
      modalRef.componentInstance.isUserLogged.subscribe((isUserLogged: any) => {
        if (isUserLogged) {
          // modalRef.componentInstance.userid.subscribe((userid: any) => {
          if (this.UserId) {
            this.isLoading = true;
            this.UserId = this.UserId;
            this.check = false;
            this.isButtonDisabled = false;
            if (this.fileToUpload) {
              this.uploadImage(this.fileToUpload, '', (updatedHtml) => {
                console.log('Updated HTML Content:', updatedHtml);
                this.storeData();
              });
            } else {
              this.storeData();
            }
          }
          // });
        }
      });
      modalRef.componentInstance.isClosedModal.subscribe((isClosedModal: any) => {
        if (isClosedModal == 'true') {
          this.check = false;
          this.isButtonDisabled = false;
        }
      });
    } else {
      if (this.fileToUpload) {
        this.uploadImage(this.fileToUpload, '', (updatedHtml) => {
          console.log('Updated HTML Content:', updatedHtml);
          this.storeData();
        });
      } else {
        if (this.fileToUpload) {
          this.uploadImage(this.fileToUpload, '', (updatedHtml) => {
            console.log('Updated HTML Content:', updatedHtml);
            this.storeData();
          });
        } else {
          this.storeData();
        }
      }
    }
  }

  closeModal() {
    this.modalService.dismissAll();
  }
  storeData() {
    const tagsList: any = [];
    this.selectedTags.forEach((tagDataId) => {
      const tag = {
        isValid: true,
        Specificulture: 'en-us',
        dataId: tagDataId.value,
        parentId: '',
        parentType: 6,
        mixDatabaseId: 8,
        mixDatabaseName: 'sys_tag',
        priority: 0,
        status: 'Published',
        isActived: true,
      };
      tagsList.push(tag);
    });

    const postQuestion = {
      grade: this.gradeID,
      catId: this.selectedID,
      cat: this.categoryName,
      userId: this.UserId,
      primaryTopicId: '1',
      answerCount: 0,
      imageUrl: this.uploadedImagePath,
      isActive: true,
      askQuestion: this.htmlContent.search('href="') > 0 ? this.htmlContent.replaceAll('href=', '') : this.htmlContent,
      //askQuestion: this.htmlToSimpleText.removeHrefHr(this.sharedData),
      nudgeDate: this.transformDate(new Date()),
      nudgeResolvedDate: this.transformDate(new Date()),
      sysTags: tagsList,
    };
    //call for post data
    this.forumService
      .create(postQuestion)
      .pipe(
        mergeMap(() => {
          return this.forumService.getDataByCat(this.selectedID, this.startIndex, this.endIndex, this.gradeID);
        })
      )
      .subscribe({
        next: (catData: any) => {
          this.getCatList = catData.forumCategoryDetail;
          this.categoryDataLenght = this.getCatList.forumCategoryDetail?.length;
          this.isLoading = false;
          this.notificationService.notifyMessage(NotificationType.Success, `We’ve received your question. Please allow some time for it to appear.`);
          this.resetForum();
          this.storage.remove(StorageKey.FORUM_RIGHT_BLOCK, StorageType.LOCAL);
          this.check = false;
          this.isSubmitted = false;
          this.isButtonDisabled = false;
          // tagsList.length = 0;
          // if (catData != null) {
          //   this.uploadImage();
          // }
          //this.forumQuestiontags.patchValue({ imageQuestion: '' });
        },
        error: (error) => {
          this.notificationService.notifyMessage(NotificationType.Fail, `Failure in posting question.`);
          this.isLoading = false;
          this.check = false;
          this.isButtonDisabled = false;
        },
      });
    //this.selectedID = data
  }

  isResolved(resolvedData: any) {
    if (resolvedData != null || resolvedData != '') {
      this.isCaptchaVerified = true;
    } else {
      this.isCaptchaVerified = false;
    }
  }
  getLastActivity(lastPostDate: Date): any {
    var utcDT = new Date();
    const diffInMilliseconds = Math.abs(
      new Date(
        utcDT.getUTCFullYear(),
        utcDT.getUTCMonth(),
        utcDT.getUTCDate(),
        utcDT.getUTCHours(),
        utcDT.getUTCMinutes(),
        utcDT.getUTCSeconds(),
        utcDT.getUTCMilliseconds()
      ).getTime() - new Date(lastPostDate).getTime()
    );

    let seconds = diffInMilliseconds / 1000;
    let minutes = seconds / 60;
    let hours = Math.floor(minutes / 60);
    let days = Math.floor(diffInMilliseconds / (60 * 60 * 24 * 1000));

    return seconds < 60
      ? Math.floor(seconds) + ' Second' + (Math.floor(seconds) === 1 ? '' : 's') + ' ago'
      : minutes <= 60
      ? Math.floor(minutes) + ' Minute' + (Math.floor(minutes) === 1 ? '' : 's') + ' ago'
      : hours <= 24
      ? hours + ' Hour' + (hours === 1 ? '' : 's') + ' ago'
      : days === 0
      ? 'Today'
      : days <= 30
      ? days + ' Day' + (days === 1 ? '' : 's') + ' ago'
      : days >= 30 && days / 30 < 12
      ? Math.floor(days / 30) + ' Month' + (Math.floor(days / 30) === 1 ? '' : 's') + ' ago'
      : Math.floor(days / 365) + ' Year' + (Math.floor(days / 365) === 1 ? '' : 's') + ' ago';
  }

  transformDate(date: string | number | Date) {
    return this.datePipe.transform(date, "yyyy-MM-ddTHH:mm:ss.SSS'Z'");
  }

  uploadImage(filename: File, folderpath: string, callback: (html: string) => void) {
    this.imageUploadService.upload_file_on_cdn(this.fileToUpload, folderpath).subscribe((response) => {
      if (response.success) {
        console.log('Image uploaded:', response.filePath);
        this.uploadedImagePath = response.filePath; // Store uploaded image path
        // const imageTag = `<img src="${response.filePath}" class="content-image" alt="Uploaded Image" style="margin-right: 79px; width: 300px; height: auto;">`;
        // this.htmlContent = this.htmlContent.concat(`<p>${imageTag}</p>`);

        callback(this.htmlContent); // Return the updated HTML content via callback
      } else {
        console.error('Upload failed:', response.message);
        callback(this.htmlContent);
      }
    });
  }

  deleteImage() {}

  get f() {
    return this.forumQuestion.controls;
  }

  getPriviousQuestion() {
    this.isCheckPrevious = true;
    this.startIndex = this.startIndex - 6 + 1;
    this.endIndex = this.endIndex - 5;
    this.forumService
      .getDataByCat(this.selectedID, this.startIndex, this.endIndex, this.gradeID)
      .subscribe((data: any) => {
        this.isViewAllNext = true;
        this.isCheckPrevious = false;
        if (this.startIndex == 1) {
          this.isViewAllPrevious = false;
          this.isViewAll = false;
        }
        this.getCatList = data.forumCategoryDetail;
        this.categoryDataLenght = this.getCatList.forumCategoryDetail?.length;
      });
  }
  getNextquestion() {
    this.isCheckNext = true;
    this.startIndex = this.endIndex + 1;
    this.endIndex = this.startIndex + 4;
    this.selectedID = this.getCatList[0].categoryId;

    this.forumService
      .getDataByCat(this.selectedID, this.startIndex, this.endIndex, this.gradeID)
      .subscribe((data: any) => {
        if (5 <= data.forumCategoryDetail?.length) {
          this.getCatList = data.forumCategoryDetail;
          this.categoryDataLenght = this.getCatList.forumCategoryDetail?.length;
          this.isViewAllNext = true;
          this.isViewAllPrevious = true;
          this.isViewAll = false;
          this.isCheckNext = false;
        } else {
          this.isViewAllNext = false;
          this.isViewAll = false;
          this.getCatList = data.forumCategoryDetail;
          this.categoryDataLenght = this.getCatList.forumCategoryDetail?.length;
        }
      });
  }

  resetForum() {
    this.check = false;
    // if (this.document.getElementsByName('files')[0]) {
    //   (this.document.getElementsByName('files')[0] as HTMLInputElement).value = '';
    // }
    this.forumQuestiontags.patchValue({ imageQuestion: '' });
    this.document.target.files[0].name;
    // const rootElement = document.querySelector('app-root');
    // if (rootElement?.hasAttribute('aria-hidden')) {
    //   rootElement.removeAttribute('aria-hidden');
    // }
    this.isAnsweUploaded = true;
    this.htmlContent = '';
    this.imageName = '';
    this.isSubmitted = false;
  }

  checkInTopicCategory(category: any): any {
   this.categorydata = this.TopicCategory.filter(
      (x: any) =>
        x.name.replaceAll('[', '-').replaceAll(']', '').replaceAll('-', ' ').toLocaleLowerCase() ==
          this.category?.replaceAll('[', '-').replaceAll(']', '').replaceAll('-', ' ').toLocaleLowerCase() &&
        x.SubCategory != 1 &&
        x.SubCategory != 2 &&
        x.SubCategory != 3 &&
        x.SubCategory != 4 &&
        x.SubCategory != 5
    ).find((x: any) => x.id);
    if (this.categorydata == undefined || this.categorydata.length == 0) {
      this.categorydata = this.TopicCategory.filter((x: any) => x.name.includes(this.category));
      if (this.categorydata == undefined || this.categorydata.length == 0) {
        this.chechInSubCategory(category);
      } else {
        this.setCategory(this.categorydata[0], null, null);
      }
    } else {
      this.parentCategoryData = this.SubCategory.filter((x: any) => x.id == this.categorydata.SubCategory);
      this.gradeData = this.ParentCategory.filter((x: any) => x.id == this.parentCategoryData[0].ParentCategory);

      this.setCategory(this.categorydata, this.parentCategoryData[0], this.gradeData[0]);
    }
  }
  chechInSubCategory(category: any) {
    const categoryUrlPattern = new RegExp(QuestionURLPattern.Pattern4_1);
    if (category.match(categoryUrlPattern)) {
      this.categoryURL = category.match(categoryUrlPattern);
      this.parentCategoryData = category.split('-');
      if (this.parentCategoryData.length == 4) {
        const parentData = this.parentCategoryData;
        const regex = /^physics|chemistry|maths|biology|-others\/$/;
        if (regex.test(this.parentCategoryData[2] + '-' + this.parentCategoryData[3].toLocaleLowerCase())) {
          const categoryname = this.htmlToSimpleText.toTitleCase(parentData[2] + ' ' + parentData[3]);
          this.categorydata = this.TopicCategory.filter((x: any) => x.name.includes(categoryname));
          if (
            (Number(parentData[0]) == 12 || Number(parentData[0]) == 11) &&
            this.htmlToSimpleText.toTitleCase(parentData[2]) == 'Maths'
          ) {
            this.parentCategoryData = this.SubCategory.filter(
              (x: any) =>
                x.ParentCategory == Number(parentData[0]) &&
                x.name.includes(this.htmlToSimpleText.toTitleCase('Mathematics'))
            );
          } else {
            this.parentCategoryData = this.SubCategory.filter(
              (x: any) =>
                x.ParentCategory == Number(parentData[0]) &&
                x.name.includes(this.htmlToSimpleText.toTitleCase(parentData[2]))
            );
          }
          this.categorydata = this.TopicCategory.filter(
            (x: any) => x.SubCategory == this.parentCategoryData[0].id && x.name.includes(categoryname)
          );
          this.gradeData = this.ParentCategory.filter((x: any) => x.id == this.parentCategoryData[0].ParentCategory);
          //this.categorydata[0].name=category.replaceAll('-',' ');
          this.setCategory(this.categorydata[0], this.parentCategoryData[0], this.gradeData[0]);
        } else {
          this.categorydata = this.TopicCategory.filter(
            (x: any) =>
              x.name.replaceAll('[', '-').replaceAll(']', '-').replaceAll('-', ' ').replaceAll('(', '-') ==
              category.replaceAll('[', '-').replaceAll(']', '-').replaceAll('-', ' ').replaceAll(')', '-')
          ).find((x: any) => x.id);
          this.setCategory(this.categorydata, null, null);
        }
      } else {
        this.setCategory(null, this.parentCategoryData, null);
      }
    } else {
      const regex = /^physics|chemistry|maths|biology|-others\/$/;
      if (regex.test(category)) {
        this.categorydata = this.TopicCategory.filter(
          (x: any) =>
            x.name.replaceAll(' ', '-').replaceAll('(', '-').replaceAll(')', '').toLocaleLowerCase() == category
        ).find((x: any) => x.id);
        this.setCategory(this.categorydata, null, null);
        // console.log('Modified Category:', modifiedCategory);
      } else {
        this.categorydata = this.TopicCategory.filter(
          (x: any) =>
            x.name.replaceAll('[', '-').replaceAll(']', '-').replaceAll('-', ' ').replaceAll('(', '-') ==
            category.replaceAll('[', '-').replaceAll(']', '-').replaceAll('-', ' ').replaceAll(')', '-')
        ).find((x: any) => x.id);
        this.setCategory(this.categorydata, null, null);
      }
    }
  }
  setCategory(categorydata: any, parentCategoryData: any, gradeData: any) {
    if (categorydata != null && parentCategoryData != null && gradeData != null) {
      this.selectedSubCategory = parentCategoryData.id;
      this.selectedSubTopicCategory = categorydata.id;
      this.categoryToRedirect = categorydata.name.replaceAll(' ', '-');
      this.dropdownCategory = this.SubCategory.filter((i: { ParentCategory: any }) => i.ParentCategory == gradeData.id);
      this.dropdownsubCategory = this.TopicCategory.filter(
        (i: { SubCategory: any }) => i.SubCategory == parentCategoryData.id
      );
      this.selectedName = categorydata.name;
      this.categoryName = this.selectedName;
      this.selectedID = this.categorydata.id;
      this.gradeID = this.parentCategoryData[0].ParentCategory;
      //this.populateCategory(Number(this.parentCategoryData[0].ParentCategory));
      this.setMetaContent(this.selectedSubTopicCategory);
    } else if (categorydata == null && parentCategoryData != null && gradeData == null) {
      if (parentCategoryData.length == 4) {
        this.categorydata = this.TopicCategory.filter(
          (x: any) =>
            x.name.replaceAll(' ', '-').toLocaleLowerCase() ==
            parentCategoryData[2] + '-' + parentCategoryData[3].toLocaleLowerCase()
        ).find((x: any) => x.id);
        this.selectedID = Number(parentCategoryData[0]);
        this.setCategory(this.categorydata, null, null);
      } else {
        this.parentCategoryData = this.SubCategory.filter(
          (x: any) =>
            x.ParentCategory == Number(parentCategoryData[0]) &&
            x.name.toLocaleLowerCase() == parentCategoryData[2].toLocaleLowerCase()
        );
        this.selectedSubCategory = this.parentCategoryData[0].id;
        this.dropdownCategory = this.SubCategory.filter(
          (i: { ParentCategory: any }) => i.ParentCategory == this.parentCategoryData[0].ParentCategory
        );
      }
      this.categoryToRedirect =
        this.parentCategoryData[0].ParentCategory + '-grade-' + this.parentCategoryData[0].name.toLowerCase();
      this.selectedName = this.parentCategoryData[0].name;
      this.categoryName = this.selectedName;
      this.selectedID = this.parentCategoryData[0].id;
      this.gradeID = this.parentCategoryData[0].ParentCategory;
      this.categoryName = this.categoryToRedirect.replaceAll('-', ' ');
      this.populateCategory(Number(this.parentCategoryData[0].ParentCategory));
      this.setMetaContent(this.selectedSubCategory);
    } else if (categorydata != null && parentCategoryData == null && gradeData == null) {
      this.categorydata = this.TopicCategory.filter(
        (x: any) => x.id == categorydata.id && x.SubCategory == categorydata.SubCategory
      );
      this.parentCategoryData = this.SubCategory.filter((x: any) => x.id == this.categorydata[0].SubCategory);
      this.selectedSubCategory = this.parentCategoryData[0].id;
      this.selectedSubTopicCategory = categorydata.id;
      this.categoryToRedirect =
        this.parentCategoryData[0].ParentCategory + '-grade-' + this.parentCategoryData[0].name.toLowerCase();
      this.dropdownsubCategory = this.TopicCategory.filter(
        (i: { SubCategory: any }) => i.SubCategory == this.parentCategoryData[0].id
      );
      this.populateCategory(Number(this.parentCategoryData[0].ParentCategory));
      this.setMetaContent(this.selectedSubTopicCategory);
    } else {
      this.router.navigate(['page-not-found'], {
        skipLocationChange: true,
      });
    }
  }

  setMetaContent(selectedSubTopicCategory: any) {
    this.forumService
      .getDataByCat(selectedSubTopicCategory, this.startIndex, this.endIndex, this.gradeID)
      .subscribe((data: any) => {
        this.getCatList = data.forumCategoryDetail;
        this.categoryDataLenght = this.getCatList.forumCategoryDetail?.length;
        this.metaContent = data.forumCategoryMeta;
        this.metaSetvice.updateMetaContent(
          this.metaContent.keyword,
          this.metaContent.description,
          this.metaContent.title,
          null,
          'forums/' + this.category?.toLocaleLowerCase() + '/',
          'forum'
        );
      });
  }
  getBlogData() {
    this.blogService.getBlogDetails(1).subscribe((data) => {
      this.pageLenght = data.headers.get('X-Wp-Total');
      this.blogs = data.body.slice(0, 2);
      this.blogCategory = 'post';
      //this.cacheService.setBlogData(this.blogs);
    });
  }
  goToBlog() {
    window.location.href = 'https://www.askiitians.com/blog/';
    this.location.replaceState('blog/');
  }
  goToBlogDetailed(slugURL: string) {
    window.location.href = 'https://www.askiitians.com/blog/' + slugURL + '/';
    this.location.replaceState('blog/' + slugURL + '/');
  }

  /*
  ngOnDestroy() {
    this.userSubscribe.unsubscribe();
    this.cacheSubscribe.unsubscribe();
  }
    */
  getQuestionDescrtion(questionDescription: string): string {
    this.questionSimpleText = this.htmlToSimpleText.RemoveHTML(questionDescription);
    return this.htmlToSimpleText.configurLatex(this.questionSimpleText);
  }

  fetchHtmlContentFromEditor(content: string) {
    this.htmlContent = content;
    this.isValidQuestion = true;
    if (this.htmlToSimpleText.RemoveHTML(this.htmlContent).length > 50) {
      this.check = false;
    }
  }

  getValue() {
    console.log('Editor Content:', this.htmlContent);
  }

  changed(newValue: any) {
    if (newValue) {
      this.check = false;
    } else {
      this.check = true;
    }
  }
  onTextInput(event: Event) {
    const inputValue = (event.target as HTMLTextAreaElement).value;
    console.log('Input value:', inputValue);
  }

  insertAtCursor(html: string) {
    const selection = window.getSelection();
    if (!selection || selection.rangeCount === 0) return;

    const range = selection.getRangeAt(0);
    range.deleteContents();

    const div = document.createElement('div');
    div.innerHTML = html;
    const frag = document.createDocumentFragment();
    let node, lastNode;

    while ((node = div.firstChild)) {
      lastNode = frag.appendChild(node);
    }

    range.insertNode(frag);

    // Move cursor to the correct position after inserting the image
    if (lastNode) {
      range.setStartAfter(lastNode);
      range.setEndAfter(lastNode);
      selection.removeAllRanges();
      selection.addRange(range);
    }
  }

  onDragOver(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation(); // Stops event bubbling
    event.dataTransfer!.dropEffect = 'copy'; // Show copy cursor
  }

  onFileChanged(event: any) {
    this.selectedFile = false;
    if (event.target.files[0].name != null) {
      const file = event.target.files[0];
      console.log('File dropped:', file.name); // Debugging

      if (file.type.startsWith('image/')) {
        this.selectedFile = true;
        this.imageName = file.name;
        let newimagename = Guid.create().toString();
        const uniqueFileName = this.generateUniqueFileName(file);
        this.fileToUpload = new File([file], uniqueFileName, { type: file.type });
        //this.uploadImage(renamedFile, 'https://files.askiitians.com/cdn1question-images/');
      } else {
        console.warn('Dropped file is not an image.');
      }
    }
  }
  generateUniqueFileName(file: File): string {
    const fileExtension = file.name.split('.').pop(); // Extract file extension
    return `${Guid.create().toString()}.${fileExtension}`; // Combine GUID with file extension
  }

  /** Converts File/Blob to base64 and sets preview */
  createImagePreview(file: File | null) {
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (e) => {
      this.imageUrl = e.target?.result as string;
    };
    reader.readAsDataURL(file);
  }
}
